<template>
  <div>
    <v-card>
      <v-card-title>
        
        <span v-if="$store.getters.vendorsIsEdit"> ویرایش وندور</span>
        <span v-else> افزودن وندور جدید</span>
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text>
        <v-form ref="vendorForm" v-model="vendorValid">
          <v-row>
            <v-col cols="12" md="4">
              <v-combobox
                deletable-chips
                v-model="selectedVendorMerchant"
                hide-selected
                label="* کسب و کار مورد نظر"
                item-text="name"
                item-value="merchantId"
                persistent-hint
                small-chips
                outlined
                dense
                clearable
                flat
                hide-no-data
                :items="merchantItems"
                :loading="merchantsLoading"
                :search-input.sync="asyncGetMerchants"
              >
              </v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                deletable-chips
                v-model="selectedVendorGroup"
                hide-selected
                label="گروه تامین کنندگان"
                item-text="title"
                item-value="id"
                persistent-hint
                small-chips
                outlined
                dense
                clearable
                flat
                hide-no-data
                :items="vendorGroupItems"
              >
              </v-combobox>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="رتبه"
                type="number"
                outlined
                dense
                v-model="vendor.Score"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-textarea
                label=" توضیحات "
                prepend-icon="mdi-comment"
                rows="2"
                row-height="20"
                outlined
                dense
                v-model="vendor.Description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="error" @click="closeForm()">انصراف</v-btn>
        <v-btn v-if="isVendorManageable" color="primary" @click="save()"> ذخیره </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
 

const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';

export default {
  components: {
   // merchantItems: [],
  },
  data() {
    return {
      selectedVendorMerchant: null,
      selectedVendorGroup:null,
      vendorValid: true,
      asyncGetMerchants: '',
      merchantsLoading: false,
      merchantItems: [],
      vendorGroupItems: [],
      vendor: {
        VendorPermissionId: this.$store.getters.currentMerchantObject.vendorPermissionId,
        VendorMerchantId: null,
        Score: null,
        VendorGroupId: null,
        Description: '',
      },
    };
  },
  computed: {
    isVendorManageable() {
      return this.$store.getters.currentMerchantObject.vendorManageable;
    },
    vendorPermissionId() {
      return this.$store.getters.currentMerchantObject.vendorPermissionId;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  created() {
  
    if (this.$store.getters.vendorsIsEdit) {
      this.fillInput(this.$store.getters.vendorsSelectedForEdit);
    }
    if (
      this.$store.getters.currentMerchantObject.vendorManageable &&
      this.$store.getters.vendorPermissionId == null
    ) {
      //Calculate it again
     
      // this.getVendorPermission(
      //   this.$store.getters.currentMerchantObject.vendorPermissionId
      // );
    }
     if (
      this.$store.getters.currentMerchantObject.vendorManageable
     
    ) {
      //Calculate it again
      this.getVendorGroups();
      
    }
  },
  watch: {
    'page.contentTypeId': function () {
      this.getContentTypebyId();
    },
    asyncGetMerchants(val) {
      this.merchantItems = [];
      if (val && val.length >= 3) {
        this.searchMerchants(val);
      }
    },
  },
  methods: {
    searchMerchants(val) {
      this.merchantItems = [];
      this.merchantsLoading = true;
      const loader = this.$loading.show();
      merchantRepository()
        .getMerchantsByname(this.merchantBaseUrl, {}, { name: val })
        .then((res) => {
          this.merchantsLoading = false;
          res.data.forEach((item) => {
            this.merchantItems.push(item);
          });
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    fillInput(data) {
 
      if (data) {
        const loader = this.$loading.show();
        merchantRepository()
          .getVendorById(data.id, this.merchantBaseUrl, )
          .then((res) => {
         
             if (res.data.vendorGroupId) {
              this.selectedVendorGroup={id:res.data.vendorGroupId,title: res.data.vendorGroupTitle}
            }
             else {
              this.selectedVendorGroup=null
            }
            this.selectedVendorMerchant = { merchantId: res.data.vendorMerchantId, name:res.data.merchantName};
            this.merchantItems = [];
            this.merchantItems.push({ merchantId: res.data.VendorMerchantId, name: res.data.merchantName })
                    this.vendor.VendorPermissionId =res.data.id,
                    this.vendor.VendorMerchantId=res.data.VendorMerchantId
                    this.vendor.Score=res.data.score
                    this.vendor.VendorGroupId =res.data.vendorGroupId
                    this.vendor.Description=res.data.description
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          })
          .finally(() => loader.hide());
      }
    },

    save() {
       
       this.vendor.VendorMerchantId = this.selectedVendorMerchant?.merchantId;
      this.vendor.VendorGroupId = this.selectedVendorGroup?.id;
       if (this.selectedVendorMerchant == null) {
        this.$dialog.error({
          text: 'کسب و کار مورد نظر انتخاب شود',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
        return;
      }

      if (
        this.$refs.vendorForm.validate() &&
        this.vendor.VendorPermissionId &&
        this.vendor.VendorMerchantId &&
        this.$store.getters.currentMerchant
      ) {
        const loader = this.$loading.show();
        if (!this.$store.getters.vendorsIsEdit) {
          merchantRepository()
            .createVendor(
              this.$store.getters.currentMerchant,
              this.vendor,
              this.merchantBaseUrl
            )
            .then(() => {
              this.$dialog.message.success('با موفقیت ثبت گردید', {
                position: 'top-left',
              });
              this.closeForm();
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        } else {
           merchantRepository()
            .editVendor(
              this.$store.getters.vendorsSelectedForEdit.id,
              this.$store.getters.currentMerchant,
              this.vendor,
              this.merchantBaseUrl,
            )
            .then(() => {
              this.$dialog.message.success('با موفقیت ویرایش گردید', {
                position: 'top-left',
              });
              this.closeForm();
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    closeForm() {
      this.$store.commit('setVendorsSelectedForEdit', null);
      this.$store.commit('setVendorsIsEdit', false);
      this.$store.commit('setVendorsFormStatus', false);
    },
    // getVendorPermission(permissionId) {
    //   const loader = this.$loading.show();
    //   merchantRepository()
    //     .getVendorPermission(permissionId, this.merchantBaseUrl)
    //     .then((res) => {
    //       //console.log('res.data.id:', res.data.id);
    //       this.$store.commit('setVendorPermissionId', res.data.id);
    //     })
    //     .catch((err) => {
    //       Helper.handleErrors(err, this);
    //     })
    //     .finally(() => loader.hide());
    // },
    getVendorGroups() {
      const loader = this.$loading.show();
      const params = {
        PageNumber: 1,
        ItemsPerpage: 100,
      };

      merchantRepository()
        .getVendorGroups(
          this.$store.getters.currentMerchant,
          this.merchantBaseUrl,
          {},
          params
        )
        .then((res) => {
          console.log('res for GroupList', res.data);
          this.vendorGroupItems = [];
          this.vendorGroupItems = res.data.list;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style lang="scss" scoped></style>
